import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { dateFormat, timeFormat } from 'helpers'
import React from 'react'

const Entry = props => {
  return (
    <div className={props.classes.entry}>
      <div className={props.classes.entryInfo}>
        <Grid container>
          <Grid item xs={4}>
            <Typography className={props.classes.entryText}>Partida y Fecha</Typography>
            <Typography className={props.classes.entryTextBold}>{props.entry.code}</Typography>
            <Typography className={props.classes.entryTextBold}>
              {dateFormat(props.entry.deliveryDate)} {timeFormat(props.entry.time)}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={props.classes.entryText}>Agricultor</Typography>
            <Typography className={props.classes.entryTextBold}>{props.entry.farmerName}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={props.classes.entryText}>Finca y Nave</Typography>
            <Typography className={props.classes.entryTextBold}>
              {props.entry.farmName}
              <br />
              {props.entry.greenhouseName}
            </Typography>
          </Grid>
        </Grid>
      </div>
      <div
        className={
          props.classes.entryNumbers +
          ' ' +
          (props.entry.invoiced
            ? props.classes.invoiced
            : props.entry.sampled
            ? props.classes.sampled
            : props.classes.pending)
        }>
        <Grid container>
          <Grid item xs={4}>
            <Typography className={props.classes.entryNumber}>
              {props.entry.netWeight.toLocaleString(undefined, { maximumFractionDigits: 2 })}
              <span className={props.classes.entryNumberUnit}>kg.</span>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={props.classes.entryNumber}>
              {props.entry.numPalets}
              <span className={props.classes.entryNumberUnit}>palets</span>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={props.classes.entryNumber}>
              {props.entry.numBoxes}
              <span className={props.classes.entryNumberUnit}>cajas</span>
            </Typography>
          </Grid>
        </Grid>
      </div>
      <div
        className={
          props.classes.entryClasification +
          ' ' +
          (props.entry.invoiced
            ? props.classes.invoiced
            : props.entry.sampled
            ? props.classes.sampled
            : props.classes.pending)
        }>
        <Grid container>
          <Grid item xs={props.entry.sampled ? 6 : 12}>
            <Typography className={props.classes.entryClasificationStatus}>
              {props.entry.invoiced ? 'Liquidado' : props.entry.sampled ? 'Clasificado' : 'Pendiente de clasificar'}
            </Typography>
          </Grid>
          {props.entry.sampled && (
            <Grid
              item
              xs={6}
              style={{ textAlign: 'right', padding: '0 10px 5px' }}
              onClick={() => props.loadSampledEntryDirectAccess(props.entry.id)}>
              <Typography>
                <span className={props.classes.goToClasification}>
                  Ver clasificación
                  <KeyboardArrowRightIcon
                    className={props.classes.goToClasificationIcon}
                    style={{ verticalAlign: 'middle' }}
                  />
                </span>
              </Typography>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  )
}

const styles = {
  entry: {
    margin: '10px 0',
    background: 'white',
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.17)',
    borderRadius: 4,
  },
  entryInfo: {
    padding: 10,
  },
  entryText: {
    fontSize: 12,
    fontWeight: 300,
    lineHeight: '16px',
  },
  entryTextBold: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px',
  },
  entryNumbers: {
    padding: '8px 0 3px',
    background: '#8ACA4C',
  },
  entryNumber: {
    fontSize: 25,
    fontWeight: 500,
    color: 'white',
    textAlign: 'center',
    lineHeight: '22px',
  },
  entryNumberUnit: {
    marginLeft: 3,
    fontSize: 12,
    fontWeight: 400,
  },
  entryClasification: {
    marginTop: 1,
    padding: '8px 0 3px',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  entryClasificationStatus: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
  },
  pending: {
    background: '#999999',
  },
  sampled: {
    background: '#E3A439',
  },
  invoiced: {
    background: '#8ACA4C',
  },
  goToClasification: {
    background: 'white',
    color: '#000',
    fontSize: 13,
    borderRadius: 4,
    padding: '2px 1px 3px 5px',
  },
  goToClasificationIcon: {
    fontSize: 17,
    fontWeight: 300,
  },
}

export default withStyles(styles)(Entry)



// WEBPACK FOOTER //
// ./src/components/Entry.js